import { categorize, categoryLabel, type Weighted } from "../../../lib/categories";
import { UNITS, fmt } from "../../../lib/units";
import { Pie } from "./Pie";

export type Selection = Weighted[];

/** The bottom-left panel: weights of the selected rows in every unit, a pie, and the categories. */
export function InfoDisplay({ selection, unitId }: { selection: Selection; unitId: number }) {
  void unitId;
  const cats = categorize(selection);
  const total = cats.reduce((s, c) => s + c.grams, 0);
  return (
    <div className="InfoDisplay">
      {selection.length === 0 ? (
        <div className="noDataDisplay">
          <span>No Items Selected</span>
        </div>
      ) : (
        <>
          <div className="weightDisplay">
            <h2>Weights</h2>
            <ul id="weightsList">
              {UNITS.map((u) => (
                <li key={u.id}>{fmt(total, u)}</li>
              ))}
            </ul>
          </div>
          <Pie categories={cats} width={100} height={100} />
          <div className="categoryDisplay">
            <ul>
              {cats.map((c) => {
                let name = categoryLabel(c.name);
                if (name.length >= 12) name = name.slice(0, 12) + "...";
                const pct = total > 0 ? Math.round((c.grams / total) * 100) : 0;
                return (
                  <li key={c.index}>
                    <span className={`colorSwatch ${c.cssClass}d`} />
                    {name}, {pct}%
                  </li>
                );
              })}
            </ul>
          </div>
        </>
      )}
    </div>
  );
}
